import React from 'react';

const InputRadioButton = ({ ans, label, value, text, handleAnswer }) => {
    return (
        <div className="form-check">
        <input
          className={"form-check-input  " + ans.valid}
          type="radio"
          name={label}
          value={value}
          checked={ans.value === value}
          onChange={() => console.log("")}
          onClick={() =>
           handleAnswer(label,value)
          }
        />
        <label className="form-check-label" htmlFor="exampleRadios1">
          {text}
        </label>
      </div>
    );
};

export default InputRadioButton;